import React from 'react';
import { motion } from 'framer-motion';
interface TimelineCardProps {
  number: number;
  title: string;
  description: string;
  details: string;
  isLast?: boolean;
  alignment?: 'left' | 'right';
}
export const TimelineCard = ({
  number,
  title,
  description,
  details,
  isLast = false,
  alignment = 'left'
}: TimelineCardProps) => {
  return <div className="relative mb-16" data-id="element-387" data-mp="6dykxec8a7vg">
      <motion.div initial={{
      opacity: 0,
      x: alignment === 'left' ? -50 : 50
    }} whileInView={{
      opacity: 1,
      x: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5
    }} className={`flex items-center gap-8 ${alignment === 'right' ? 'flex-row-reverse' : ''}`} data-id="element-388" data-mp="u3ja4eyz61d6">
        <div className={`w-1/2 ${alignment === 'right' ? 'text-right' : ''}`} data-id="element-389" data-mp="1d1ls49t3uy1h">
          <motion.div whileHover={{
          scale: 1.02
        }} className="inline-block bg-[#231232]/70 backdrop-blur-md border border-[#6805DA]/20 rounded-xl p-6 shadow-lg transition-all duration-300 hover:border-[#FFC501]/40" data-id="element-390" data-mp="1hsu2b829enfp">
            <h3 className="font-outfit text-xl font-bold mb-2 text-white" data-id="element-391" data-mp="20iicpu01l9ss">
              {title}
            </h3>
            <p className="text-gray-300 mb-4" data-id="element-392" data-mp="2fbami4sq1qcz">{description}</p>
            <p className="text-[#FFC501]/80 text-sm" data-id="element-393" data-mp="2ah6i9taubwfl">{details}</p>
          </motion.div>
        </div>
        <div className="relative" data-id="element-394" data-mp="2o8l1o18ntzn6">
          <motion.div whileHover={{
          scale: 1.1
        }} className="w-16 h-16 rounded-full bg-gradient-to-br from-[#FFC501] to-[#DF4425] flex items-center justify-center shadow-lg shadow-[#FFC501]/20 relative z-10" data-id="element-395" data-mp="2k8ko0itdxsh6">
            <span className="text-[#231232] font-outfit font-bold text-2xl" data-id="element-396" data-mp="2ta1y9kk42zxy">
              {number}
            </span>
          </motion.div>
          {!isLast && <motion.div initial={{
          height: 0
        }} whileInView={{
          height: '100%'
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="absolute top-16 left-1/2 -translate-x-1/2 w-0.5 bg-gradient-to-b from-[#FFC501]/30 to-transparent" data-id="element-397" data-mp="yw9hd5zjk8fx" />}
        </div>
        <div className="w-1/2" data-id="element-398" data-mp="3hvjx4gnuuf3v" />
      </motion.div>
    </div>;
};